import { def } from '@goldblack/shared';

// client-shared
import { storage } from '@goldblack/client-storage';
import { log } from '@goldblack/client-utils';

function authencated(data) {
    const { user, config, setting } = data;
    storage.transience.setState({
        userSession: user,
        serverConfig: config,
        'path.gateway': 'main',
        setting: setting,
    });
}

function handleResponse(res) {
    let code = res.data.code;
    let message = res.data.message;

    switch (code) {
        case def.ErrorCode.AUTH_UNAUTHORIZED:
            storage.transience.setState('path.gateway', 'login');
            break;
        case def.ErrorCode.AUTH_BANNED_USER:
            storage.transience.setState('internal.error', 'blocked user');
            break;
        default:
            if (import.meta.env.MODE === 'production') {
                message = `Error ${code}`;
            }
            storage.transience.setState('internal.error', message);
            break;
    }
}

function handleError(err) {
    if (err.response) {
        let message = '';
        switch (err.response.status) {
            case def.StatusCodes.INTERNAL_SERVER_ERROR:
                message = 'Something went wrong while processing your request. Please try again in a moment.';
                break;
            case def.StatusCodes.NOT_IMPLEMENTED:
                message = 'This feature isn’t available yet. It will be supported in a future update.';
                break;
            case def.StatusCodes.BAD_GATEWAY:
                message = 'There was a problem connecting to the server. Please try again soon.';
                break;
            case def.StatusCodes.SERVICE_UNAVAILABLE:
                message = 'The server is temporarily unavailable. Please try again in a moment.';
                break;
            case def.StatusCodes.GATEWAY_TIMEOUT:
                message = 'The server is taking longer than expected to respond. Please try again later.';
                break;
            default:
                message = 'An unexpected error occurred. Please try again.';
                break;
        }
        storage.transience.setState('internal.error', message);

        if (import.meta.env.MODE === 'development') {
            log.consoleError(`status:${err.response.status} data:${JSON.stringify(err.response.data)}`);
        }
    }
}

export { authencated, handleResponse, handleError };
